import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import type { CivilShelterInfo } from "./MapModel";
import { COLORS } from "constants/variables";

const Details = styled.dl`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 12px 16px;
  width: 100%;
  padding-top: 16px;
  border-top: 1px solid ${COLORS.MetalicSilver};
  font-size: 14px;
  line-height: 1.5;
  dt { font-weight: 600; }
  dd { margin: 0; overflow-wrap: anywhere; }
`;

const ShelterDetails = ({ shelter }: { shelter: CivilShelterInfo }) => {
  const { t } = useTranslation();
  const county = shelter.judet_id?.data?.attributes;
  const rows = [
    { key: "locality", value: shelter.localitate },
    { key: "county", value: county?.nume },
    { key: "countyCode", value: county?.abreviere },
    {
      key: "ownership",
      value: typeof shelter.proprietate_publica === "boolean"
        ? t(`map.shelter.${shelter.proprietate_publica ? "public" : "private"}`)
        : null,
    },
    { key: "status", value: shelter.stare ? t(`map.shelter.${shelter.stare}`) : null },
    { key: "capacity", value: shelter.capacitate != null ? t("map.shelter.people", { count: shelter.capacitate }) : null },
  ].filter((row) => row.value != null && row.value !== "");

  if (rows.length === 0) return null;

  return (
    <Details>
      {rows.map(({ key, value }) => (
        <React.Fragment key={key}>
          <dt>{t(`map.shelter.${key}`)}</dt>
          <dd>{value}</dd>
        </React.Fragment>
      ))}
    </Details>
  );
};

export default ShelterDetails;
